var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.512 0.635524C4.013 1.16079 0.5 5.22256 0.5 10.1435C0.5 15.4206 4.538 19.7131 9.5 19.7131C14.462 19.7131 18.5 15.4206 18.5 10.1435C18.5 5.22256 14.987 1.16079 10.488 0.635524C9.71151 0.580984 9.3049 0.58127 8.512 0.635524ZM9.5 17.3207C5.778 17.3207 2.75 14.1011 2.75 10.1435C2.75 6.18591 5.778 2.96627 9.5 2.96627C13.222 2.96627 16.25 6.18591 16.25 10.1435C16.25 14.1011 13.222 17.3207 9.5 17.3207ZM11.5 10.1435H9.5V8.0169C9.5 7.4289 9.052 6.95361 8.5 6.95361C7.948 6.95361 7.5 7.4289 7.5 8.0169V11.2068C7.5 11.7948 7.948 12.2701 8.5 12.2701H11.5C12.052 12.2701 12.5 11.7948 12.5 11.2068C12.5 10.6188 12.052 10.1435 11.5 10.1435Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.dd1d4afc53afcbb7b96fa4e816cde8d0.svg";
export { ForwardRef as ReactComponent };